export const smsSteps = [
    {
        label: 'Шаг',
        to: "/login/forgot/options"
    },
    {
        label: 'Шаг',
        to: "/login/forgot/sms-step-two"
    },
    {
        label: 'Шаг',
        to: "/login/forgot/sms-step-three",
    },
    {
        label: 'Шаг',
        to: "/login/forgot/new-password",
    },
]
export const emailSteps = [
    {
        label: 'Шаг',
        to: "/login/forgot/options"
    },
    {
        label: 'Шаг',
        to: "/login/forgot/email-step-two"
    },
    {
        label: 'Шаг',
        to: "/login/forgot/email-step-three",
    },
    {
        label: 'Шаг',
        to: "/login/forgot/new-password",
    },
]